import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAlertsHeatmap } from '../../services/AlertsService';
import { AlertsHeatmapResponse } from '../../types/Alerts';

function useGetAlertsHeatmap(fleetId: string, query?: string): UseQueryResult<AlertsHeatmapResponse> {
  return useQuery(
    ['alerts-heatmap', fleetId, query],
    async (): Promise<AlertsHeatmapResponse> => getAlertsHeatmap(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetAlertsHeatmap;
